import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Document} from '../../../shared/interface/document';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {HttpErrorResponse} from '@angular/common/http';
import {KrkService} from '../../../shared/services/krk.service';
import {Krk} from '../../../shared/interface/krk';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {DocumentAddDialogComponent} from '../../documents/document-add-dialog/document-add-dialog.component';
import {FILE_TYPE_KRK} from '../../../shared/services/dict.service';

@Component({
  selector: 'app-krk-details',
  templateUrl: './krk-details.component.html',
  styleUrls: ['./krk-details.component.scss']
})
export class KrkDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  krkId: string;
  krkObject?: Krk;
  krk: ReplaySubject<Krk> = new ReplaySubject<Krk>(1);
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private krkService: KrkService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.krkId = params.id;
        this.loadKrk();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 1) {
      this.loadDocuments();
    }
  }

  loadDocuments(): void {
    this.krkService.getKrkDocuments(this.krkId)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        krkObject: this.krkObject,
        types: [FILE_TYPE_KRK],
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDocuments();
    });
  }

  loadKrk(): void {
    this.krkService.get(this.krkId).subscribe((krk: Krk) => {
      this.krk.next(krk);
      this.krkObject = krk;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych KRK', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
